import { Component, OnDestroy, OnInit, inject, input, output } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject, takeUntil } from 'rxjs';

export interface Option {
	id: number;
	name: string;
}

@Component({
	selector: 'app-fast-filters',
	standalone: true,
	imports: [NgSelectModule, ReactiveFormsModule],
	templateUrl: './fast-filters.component.html',
})
export class FastFiltersComponent implements OnInit, OnDestroy {
	placeholder = input.required<string>();
	options = input.required<Option[]>();

	optionChanged = output<Option>();

	form = inject(FormBuilder).group({
		optionId: new FormControl(),
	});

	private readonly destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.optionChanged.emit(this.options().find((o) => o.id === this.form.controls.optionId.value));
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	clear(): void {
		this.form.controls.optionId.setValue(null);
	}
}
